export default __webpack_public_path__ + "static/media/7_4_logo.fc1664fe.png";